/**
 * Copyright (c) 2019 - 2023, all rights reserved.
 * State Of New Jersey Department Of Human Services
 * Division Of Family Development
 *
 * File: "screen-constants"
 * Project: "NJFLOURISH"
 * File Created: "24-Feb-2020"
 * Author: "Protech Solutions"
 * Description: "Constant file for Screen Code"
 *
 * History
 * -------
 * Last Modified: "24-Feb-2020"
 * Modified By: "Protech Solutions"
 * Update Comments: "reason for modification"
 * -----
 */
import { Injectable } from "@angular/core";

@Injectable()
export class ScreenConstants {
  /*Screen Code for Address History */
  readonly AHIS: string = "AHIS";
  readonly EHIS: string = "EHIS";
  readonly ASMT: string = "ASMT";
  readonly BSTL: string = "BSTL";
  readonly CASE: string = "CASE";
  readonly CPRO: string = "CPRO";
  readonly CSUM: string = "CSUM";
  readonly DCKT: string = "DCKT";
  readonly DEMO: string = "DEMO";
  readonly DPRO: string = "DPRO";
  readonly DREF: string = "DREF";
  readonly FIPS: string = "FIPS";
  readonly ICOR: string = "ICOR";
  readonly INEX: string = "INEX";
  readonly INSR: string = "INSR";
  readonly LRQS: string = "LRQS";
  readonly LSRC: string = "LSRC";
  readonly LDAT: string = "LDAT";
  readonly PARM: string = "PARM";
  readonly PROC: string = "PROC";
  readonly PSOI: string = "PSOI";
  readonly PAST: string = "PAST";
  readonly PDRF: string = "PDRF";
  readonly PSCH: string = "PSCH";
  readonly PLIC: string = "PLIC";
  readonly PTRE: string = "PTRE";
  readonly RSTR: string = "RSTR";
  readonly REFM: string = "REFM";
  readonly SRCH: string = "SRCH";
  readonly SOIN: string = "SOIN";
  readonly SOPR: string = "SOPR";
  readonly SMSG: string = "EMSG";
  readonly SPRO: string = "SPRO";
  readonly OTHP: string = "OTHP";
  readonly USEM: string = "USEM";
  readonly WRKL: string = "WRKL";
  readonly DRRQ: string = "DRRQ";
  readonly OWIZ: string = "OWIZ";
  readonly LPDR: string = "LPDR";
  readonly VISI: string = "VISI";
  readonly PHIS: string = "PHIS";
  readonly GTST: string = "GTST";
  readonly NOTE: string = "NOTE";
  readonly IVMG: string = "IVMG";
  readonly MCAL: string = "MCAL";
  readonly GDLN: string = "GDLN";
  readonly CBAT: string = "CBAT";
  readonly RPOS: string = "RPOS";
  readonly BHIS: string = "BHIS";
  readonly TAXI: string = "TAXI";
  readonly EDOC: string = "EDOC";
  readonly DSBV: string = "DSBV";
  readonly COMP: string = "COMP";
  readonly CREC: string = "CREC";
  readonly BWLT: string = "BWLT";
  readonly SLOG: string = "SLOG";
  readonly EFTI: string = "EFTI";
  readonly DHLD: string = "DHLD";
  readonly FEES: string = "FEES";
  readonly RHIS: string = "RHIS";
  readonly SMRG: string = "SMRG";
  readonly IVAC: string = "IVAC";
  readonly PMRG: string = "PMRG";
  readonly CPWI: string = "CPWI";
  readonly ELOG: string = "ELOG";
  readonly RREP: string = "RREP";
  readonly OBAA: string = "OBAA";
  readonly AEIS: string = "AEIS";
  readonly FDOC: string = "FDOC";
  readonly FHOM: string = "FHOM";
  readonly FCCS: string = "FCCS";
  readonly SAST: string = "SAST";
  readonly KCAL: string = "KCAL";
  readonly TASK: string = "TASK";
  readonly CPDR: string = "CPDR";
  readonly SORD: string = "SORD";
  readonly CPIM: string = "CPIM";
  readonly IMCL: string = "IMCL";
  readonly DPCR: string = "DPCR";
  readonly IWNS: string = "IWNS";
  readonly MDIN: string = "MDIN";
}
